export default __webpack_public_path__ + "static/juice-e3f934067923eb40f8d69eda5b06b028.png";